import { render, staticRenderFns } from "./AboutHistory.vue?vue&type=template&id=2829f94d&"
import script from "./AboutHistory.vue?vue&type=script&lang=js&"
export * from "./AboutHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports